export default function MissionSection() {
  return (
    <section className="py-24 bg-[#FAF7FC]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-6">
          <span className="text-xs font-semibold uppercase tracking-[4px] text-[#7B2D8B]">Our Purpose</span>
        </div>

        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 text-center leading-tight mb-6 max-w-3xl mx-auto">
          Changing the Narrative Around <em className="not-italic text-[#7B2D8B]">Epilepsy in Africa</em>
        </h2>
        <p className="text-gray-500 text-center text-lg max-w-2xl mx-auto mb-16 leading-relaxed">
          We exist to fundamentally transform how epilepsy is understood, treated, and lived with — building a future of inclusion, dignity, and equitable care.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white rounded-2xl p-10 border border-purple-100">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#7B2D8B]/10 mb-6">
              <i className="ri-focus-3-line text-[#7B2D8B] text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Our Mission</h3>
            <p className="text-gray-500 leading-relaxed text-sm">
              To proactively increase epilepsy awareness, facilitate effective treatment, empower communities, and advocate for transformative policies. We achieve this through a strategic blend of education, collaborative partnerships, and compassionate humanitarian services designed to create lasting change.
            </p>
          </div>
          <div className="bg-[#7B2D8B] rounded-2xl p-10">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/20 mb-6">
              <i className="ri-eye-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">Our Vision</h3>
            <p className="text-white/85 leading-relaxed text-sm">
              A society where every individual living with epilepsy enjoys full inclusion, equitable access to quality care, and lives with dignity — free from the burden of stigma. We believe in a future where understanding replaces fear, and support systems are robust and accessible to all.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            {
              icon: 'ri-megaphone-line',
              title: 'Awareness & Education',
              desc: 'Raising public understanding and dispelling myths about epilepsy through school campaigns, digital content, and community sensitization.',
            },
            {
              icon: 'ri-hand-heart-line',
              title: 'Support & Empowerment',
              desc: 'Providing vital resources and fostering resilience for individuals and families through support groups, medication assistance, and counselling.',
            },
            {
              icon: 'ri-government-line',
              title: 'Advocacy & Outreach',
              desc: 'Championing better healthcare systems and community-led initiatives through policy engagement, research, and stakeholder collaboration.',
            },
          ].map((item) => (
            <div key={item.title} className="flex gap-4 p-6 bg-white rounded-2xl border border-purple-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#7B2D8B]/10 shrink-0 mt-1">
                <i className={`${item.icon} text-[#7B2D8B] text-lg`}></i>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-2 text-sm">
                  <a href="#pillars">{item.title}</a>
                </h4>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
